export class RadiographyResultModel {
  privateId: number;
  receptionNo: string;
  nationalCode: string;
  firstName: string;
  lastName: string;
  pacsId: string;
  receptionDate: string;
  receptionTime: string;
  age: number;
  report: string;
  insuranceName: string;
  persianPrintDateTime: string;
}
